import { publicRoutes } from "../routes/__root";

/**
 * Utility to create route metadata with authentication requirements
 * This is now just for developer convenience to mark routes as
 * public or private in a consistent way.
 */
export const createRouteConfig = (options: { 
  isPublic?: boolean;
  seo?: {
    title?: string;
    description?: string;
    ogTitle?: string;
    ogDescription?: string;
  }
} = {}) => {
  const { isPublic = false, seo } = options;
  
  return {
    meta: {
      auth: {
        isPublic,
      },
      seo,
    }
  };
};

/**
 * Add a route to the public routes array
 */
export const addPublicRoute = (path: string): void => {
  if (!publicRoutes.includes(path)) {
    publicRoutes.push(path);
  }
};